import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Link from "@mui/material/Link";
import { useTheme } from "@mui/material/styles";
import MainContainer from "parts/mainContainer";

const MainContent = () => {
  const { palette } = useTheme();

  return (
    <MainContainer>
      <Box py={8}>
        <Grid container spacing={6}>
          {/* Left Column */}
          <Grid item xs={12} md={8}>
            {/* Head Office */}
            <Box mb={5}>
              <Typography
                variant="h6"
                fontWeight={700}
                color="secondary.main"
                gutterBottom
              >
                Head Office
              </Typography>
              <Typography variant="body1">
                Plot 28–30, Clement Hill Rd., Kampala
              </Typography>
              <Typography variant="body1">
                P.O. Box 133537, Kampala, UGANDA
              </Typography>
            </Box>

            {/* Active Service Centres */}
            <Box mb={5}>
              <Typography
                variant="h6"
                fontWeight={700}
                color="secondary.main"
                gutterBottom
              >
                Active Service Centres
              </Typography>
              <List
                dense
                disablePadding
                sx={{
                  listStyleType: "disc",
                  pl: 3,
                  "& .MuiListItem-root": {
                    display: "list-item",
                  },
                }}
              >
                {[
                  "Main Service Centre – Head Office Nakasero",
                  "Ntinda Service Centre – Ntinda Complex",
                  "Ntinda Service Point – Fraine Supermarket Building",
                ].map((centre, index) => (
                  <ListItem
                    key={index}
                    sx={{ display: "list-item", pl: 2, listStyleType: "disc" }}
                  >
                    <Typography variant="body1">{centre}</Typography>
                  </ListItem>
                ))}
              </List>
            </Box>

            {/* General Inquiries */}
            <Box mb={5}>
              <Typography
                variant="h6"
                fontWeight={700}
                color="secondary.main"
                gutterBottom
              >
                General Inquiries
              </Typography>
              <Typography variant="body1">
                For all general inquiries, please email us at{" "}
                <Link
                  href="mailto:admin@talkiomobile.com"
                  underline="hover"
                  color={palette.primary.main}
                  fontWeight={600}
                >
                  admin@talkiomobile.com
                </Link>
              </Typography>
            </Box>

            {/* Customer Service */}
            <Box>
              <Typography
                variant="h6"
                fontWeight={700}
                color="secondary.main"
                gutterBottom
              >
                Customer Service
              </Typography>
              <Typography variant="body1" mb={1}>
                Our customer service team is available <strong>24/7</strong> to
                assist you.
              </Typography>
              <List
                dense
                disablePadding
                sx={{
                  listStyleType: "disc",
                  pl: 3,
                  "& .MuiListItem-root": {
                    display: "list-item",
                  },
                }}
              >
                <ListItem
                  sx={{ display: "list-item", pl: 2, listStyleType: "disc" }}
                >
                  <Typography variant="body1">
                    Email:{" "}
                    <Link
                      href="mailto:hello@talkiomobile.com"
                      underline="hover"
                      color={palette.primary.main}
                      fontWeight={600}
                    >
                      hello@talkiomobile.com
                    </Link>
                  </Typography>
                </ListItem>
                <ListItem
                  sx={{ display: "list-item", pl: 2, listStyleType: "disc" }}
                >
                  <Typography variant="body1" fontWeight={600}>
                    Customer Care Line:{" "}
                    <Link href="tel:100" underline="hover" color="inherit">
                      100 (Toll-Free)
                    </Link>{" "}
                    /{" "}
                    <Link
                      href="tel:+256203100100"
                      underline="hover"
                      color="inherit"
                    >
                      +256 203 100100
                    </Link>
                  </Typography>
                </ListItem>
              </List>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </MainContainer>
  );
};

export default MainContent;
